import React, { useState, useEffect, useContext } from 'react';
import { GlobalStateContext } from './GlobalState';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import PlaylistTableInline from './PlaylistTableInline';

const PlaylistsCarousel = ({ servicename = '/playlistsx', p }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { getCachedPlaylists, setCachedPlaylists } = useContext(GlobalStateContext);

  const next = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === Math.ceil(data.length / 2) - 1 ? 0 : prevIndex + 1
    );
  };

  const prev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? Math.ceil(data.length / 2) - 1 : prevIndex - 1
    );
  };

  const shouldCache = (servicename, p) => {
    // Cache all playlists
    if (servicename === '/playlistsx') return true;
    //if (servicename === '/fixed-playlists-x' && ['best2024', 'fixed'].includes(p)) return true;  // if want to cache less
    if (servicename === '/fixed-playlists-x') return true;
    return false;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Create a consistent cache key that includes both servicename and p
        const cacheKey = p ? `${servicename}?p=${p}` : servicename;
        
        // Always check cache first regardless of shouldCache
        const cachedData = getCachedPlaylists(cacheKey);
        if (cachedData) {
          console.log(`Using cached data for ${cacheKey}`);
          setData(cachedData);
          setLoading(false);
          return;
        }

        console.log(`Fetching fresh data for ${cacheKey}`);
        const url = cacheKey; // Use the same format as cache key for URL
        const response = await fetch(url);
        if (response.status === 401 || response.status === 500) {
          window.location.href = '/';
          return;
        }
        const jsonData = await response.json();
        setData(jsonData);
        
        if (shouldCache(servicename, p)) {
          console.log(`Caching data for ${cacheKey}`);
          setCachedPlaylists(cacheKey, jsonData);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [servicename, p]); // Remove getCachedPlaylists and setCachedPlaylists from deps

  if (loading) {
    return <div className="text-center py-4">Loading...</div>;
  }

  return (
    <div className="relative max-w-6xl mx-auto px-4 py-8 bg-black">
      <div className="overflow-hidden relative">
        <div 
          className="flex transition-transform duration-300 ease-out"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {Array.from({ length: Math.ceil(data.length / 2) }).map((_, slideIndex) => (
            <div key={slideIndex} className="w-full flex-shrink-0 flex gap-4 px-4" style={{ backgroundColor: '#000000' }}>
              {data.slice(slideIndex * 2, slideIndex * 2 + 2).map((playlist, index) => (
                <div 
                  key={playlist.id || index}
                  className="flex-1 bg-dark rounded-lg p-6 shadow-sm"
                  style={{ backgroundColor: '#000000' }}
                >
                 <img src={playlist.image} alt={playlist.name}  width='149' height='149' /> <br/>
                  <PlaylistTableInline list_id={playlist.id} list_name={playlist.name} />
                 
                  <p className="text-gray-600 mb-4">{playlist.numberOfTracks} Tracks </p> 
                  
                  
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <button 
        onClick={prev}
        className="absolute left-0 top-1/2 -translate-y-1/2 bg-dark hover:bg-secondary p-2 rounded-full shadow-md z-10"
      >
        <ChevronLeftIcon className="h-6 w-6 text-white" />
      </button>
      <button 
        onClick={next}
        className="absolute right-0 top-1/2 -translate-y-1/2 bg-dark hover:bg-secondary p-2 rounded-full shadow-md z-10"
      >
        <ChevronRightIcon className="h-6 w-6 text-white" />
      </button>
    </div>
  );
};

export default PlaylistsCarousel;
